import React, { createContext, useState, useMemo } from 'react'

import { useCurrentPost } from '~/app/state/hooks'

// Global context:
// - Current Organization.
// - Current Channel.
// - Current Post.
// - Filter.

/**
 *
 */
// @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 0.
export const AppContext = createContext()

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'children' implicitly has an 'any'... Remove this comment to see the full error message
const AppProvider = ({ children }) => {
  const { mutateCurrentPost } = useCurrentPost()

  /// ////////////////////////////////////////////
  // Filter
  /// ////////////////////////////////////////////
  const [filter, setFilter] = useState(null)

  // @ts-expect-error TS(7006) FIXME: Parameter 'label' implicitly has an 'any' type.
  const onFilter = (label) => {
    mutateCurrentPost(null)
    // @ts-expect-error TS(2345) FIXME: Argument of type '{ by: string; value: any; }' is ... Remove this comment to see the full error message
    setFilter({ by: 'label', value: label })
  }

  const onClearFilter = () => {
    setFilter(null)
  }

  const filterValue = useMemo(
    () => ({
      filter,
      onFilter,
      onClearFilter,
    }),
    [filter],
  )

  return (
    <AppContext.Provider
      value={{
        ...filterValue,
      }}
    >
      {children}
    </AppContext.Provider>
  )
}

export default AppProvider
